import { createApp, defineAsyncComponent } from "vue";
import App from "./App.vue";
import { createRouter, createWebHistory } from "vue-router";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import "primeicons/primeicons.css";
import VueLazyLoad from "vue3-lazyload";

import "./assets/tailwind.css";
import "./styles/main.css";

/* ---------------- ROUTES ---------------- */

const routes = [
  {
    path: "/",
    component: defineAsyncComponent(() =>
      import("./components/main/LandingPage.vue")
    ),
  },
  {
    path: "/services",
    component: defineAsyncComponent(() =>
      import("./components/main/Services.vue")
    ),
  },
  {
    path: "/projects",
    component: defineAsyncComponent(() =>
      import("./components/main/ProjectsComponent.vue")
    ),
  },
  {
    path: "/about-us",
    component: defineAsyncComponent(() =>
      import("./components/main/AboutUs.vue")
    ),
  },
  {
    path: "/contact-us",
    component: defineAsyncComponent(() =>
      import("./components/main/ContactUs.vue")
    ),
  },
  {
    path: "/catalogues",
    component: defineAsyncComponent(() =>
      import("./components/main/CatalogueComponent.vue")
    ),
  },
  {
    path: "/news",
    component: defineAsyncComponent(() =>
      import("./components/main/NewsComponent.vue")
    ),
  },
  {
    path: "/supplier/:id",
    component: defineAsyncComponent(() =>
      import("./components/main/SupplierDetails.vue")
    ),
  },
  {
    path: "/our-brands",
    component: defineAsyncComponent(() =>
      import("./components/main/brandsPage.vue")
    ),
  },

  /* -------- TEST ROUTES -------- */

  {
    path: "/test",
    component: defineAsyncComponent(() =>
      import("./components/main/LandingPage.vue")
    ),
  },
  {
    path: "/test/services",
    component: defineAsyncComponent(() =>
      import("./components/main/Services.vue")
    ),
  },
  {
    path: "/test/projects",
    component: defineAsyncComponent(() =>
      import("./components/main/ProjectsComponent.vue")
    ),
  },
  {
    path: "/test/about-us",
    component: defineAsyncComponent(() =>
      import("./components/main/AboutUs.vue")
    ),
  },
  {
    path: "/test/contact-us",
    component: defineAsyncComponent(() =>
      import("./components/main/ContactUs.vue")
    ),
  },
  {
    path: "/test/catalogues",
    component: defineAsyncComponent(() =>
      import("./components/main/CatalogueComponent.vue")
    ),
  },
  {
    path: "/test/news",
    component: defineAsyncComponent(() =>
      import("./components/main/NewsComponent.vue")
    ),
  },
  {
    path: "/test/supplier/:id",
    component: defineAsyncComponent(() =>
      import("./components/main/SupplierDetails.vue")
    ),
  },
  {
    path: "/test/our-brands",
    component: defineAsyncComponent(() =>
      import("./components/main/brandsPage.vue")
    ),
  },
];

/* ---------------- ROUTER ---------------- */

const router = createRouter({
  history: createWebHistory(),
  routes,

  scrollBehavior(to, from, savedPosition) {
    // ✅ browser back/forward
    if (savedPosition) {
      return savedPosition;
    }

    // ✅ always go to top on new navigation
    return { top: 0 };
  },
});

/* ---------------- GLOBAL TEST MODE DETECTION ---------------- */

router.isTestMode = false;

router.beforeEach((to, from, next) => {
  router.isTestMode = to.path.startsWith("/test");
  next();
});

/* ---------------- APP ---------------- */

const app = createApp(App);

/* ---------------- PINIA ---------------- */

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
app.use(pinia);

/* ---------------- ROUTER ---------------- */

app.use(router);

/* ---------------- LAZYLOAD ---------------- */

app.use(VueLazyLoad, {
  observer: true,
});

/* ---------------- MOUNT ---------------- */

app.mount("#app");